module.exports = __webpack_public_path__ + "img/video-player/comment_stroke_default-f6ca2e026f0848d33eeb8dea1777962c.svg";